import { render, staticRenderFns } from "./vehiclesContainer.vue?vue&type=template&id=81e55134"
import script from "./vehiclesContainer.vue?vue&type=script&lang=js"
export * from "./vehiclesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports